import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import "./index.css";
import "./App.css";
import { StrictMode } from "react";
import App from "./App.tsx";
import { loadGoogleAnalyticsWebOnly } from "./lib/loadGoogleAnalytics.js";
import { initSentry } from "./lib/sentry.js";
import { IS_NATIVE_APP } from "./config/appTarget.js";
import "./i18n/config.js";

// Initialise crash/error reporting as early as possible on native builds so the
// native crash handler is installed before anything else can fail. No-op on web
// and when no DSN is configured.
initSentry();

loadGoogleAnalyticsWebOnly();

async function initNativeShell() {
  // IS_NATIVE_APP also covers the dev-only localStorage override (see
  // config/appTarget.ts), so the CSS switch matches React's own native check
  // when testing the mobile layout in a plain browser.
  if (!Capacitor.isNativePlatform() && !IS_NATIVE_APP) return;
  // Remove the web-navbar body padding and signal native mode to CSS
  document.body.classList.add("native-app");
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    // Android: transparent status bar with no system blur — dark icons needed
    // on the cream (#f9f7f4) background. iOS keeps Light (system blur handles contrast).
    await StatusBar.setStyle({
      style: Capacitor.getPlatform() === "android" ? Style.Dark : Style.Light,
    });
  } catch {
    // Status bar plugin optional during dev
  }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    // Hide after first paint — requestAnimationFrame gives the renderer one
    // frame to flush the React tree before we dismiss the splash.
    requestAnimationFrame(() => {
      SplashScreen.hide({ fadeOutDuration: 300 });
    });
  } catch {
    // SplashScreen plugin optional during dev
  }
}

void initNativeShell();

// console.group('🕵️ Environment Diagnostics');
// // console.log('Import Meta Env:', import.meta.env);
// // console.log('Environment Mode:', import.meta.env.MODE);
// // console.log('Is Production:', import.meta.env.PROD);
// // console.log('Is Development:', import.meta.env.DEV);
// console.groupEnd();
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <div className="wrapper">
      <div className="main-container">
        <App />
      </div>
    </div>
  </StrictMode>,
);
